import { Plugin } from 'tiptap'
import { Image } from 'tiptap-extensions'
import { get } from 'lodash'
import { tinymceUploadImg } from '@/api/upload'
export default class ImageUpload extends Image {
  constructor (options = {}) {
    super(options)
    this.uploader = options.uploader
  }
  get name () {
    return 'copy_image'
  }
  get plugins () {
    const uploader = this.uploader
    const that = this
    return [
      new Plugin({
        props: {
          handleDOMEvents: {
            paste (view, event) {
              const items = Array.from((event.clipboardData || event.originalEvent.clipboardData).items)
              if (!uploader) {
                return
              }
              items.forEach(async item => {
                const { schema } = view.state
                const image = item.getAsFile()
                // Return here, otherwise copying texts won't possible anymore
                if (!image) {
                  return
                }
                event.preventDefault()
                const imageSrc = await that.uploader(image)
                console.log('------src-----------', imageSrc,schema);
                const node = schema.nodes.image.create({
                  src: imageSrc,
                  width: parseFloat(image.width)
                })
                const transaction = view.state.tr.replaceSelectionWith(node)
                view.dispatch(transaction)
              })
            },
            drop (view, event) {
              const hasFiles = event.dataTransfer.files.length > 0
              if (!hasFiles) {
                return
              }
              event.preventDefault()
              const images = event.dataTransfer.files
              const { schema } = view.state
              const coordinates = view.posAtCoords({ left: event.clientX, top: event.clientY })
              images.forEach(async image => {
                if (!uploader) {
                  return
                }
                const imageSrc = await that.uploader(image)
                if (imageSrc) {
                  const node = schema.nodes.image.create({
                    src: imageSrc,
                    width: parseFloat(image.width)
                  })
                  const transaction = view.state.tr.insert(coordinates.pos, node)
                  view.dispatch(transaction)
                }
              })
            },
          },
        },
      }),
    ]
  }

  async uploadImage(selectedFile) {
    if (!['image/jpeg', 'image/png', 'image/gif'].includes(selectedFile.type)) {
      Message.error('只能上传图片文件')
      return
    }
    this.imageUploadInProgress = true
    return tinymceUploadImg(selectedFile, selectedFile.name)
      .then((registerDirectUploadResponse) => {
        const imgurl = `${process.env.VUE_APP_BASE_API}/attachment/${registerDirectUploadResponse.data}`
        return imgurl
      })
      .catch((e) => {
        Message.error(e.message)
      })
      .finally(() => {
        this.imageUploadInProgress = false
      })
  }
}